import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/new-design/images/sign-in.png'
import _imports_1 from '@/assets/new-design/images/sign-up.png'
import _imports_2 from '@/assets/new-design/images/logo-white.png'
import _imports_3 from '@/assets/new-design/images/login-image.png'


const _withScopeId = n => (_pushScopeId("data-v-5c9da094"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-column flex-lg-row flex-column-fluid",
  id: "login-container"
}
const _hoisted_2 = {
  class: "d-flex flex-column flex-lg-row-fluid flex-lg-row-auto py-10 w-50-p",
  style: {"background":"#fff"}
}
const _hoisted_3 = { class: "d-flex flex-center flex-column flex-column-fluid" }
const _hoisted_4 = { class: "w-lg-500px p-10 p-lg-15 mx-auto d-flex flex-column align-items-center justify-content-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Submit a Tenant Report", -1))
const _hoisted_6 = { class: "option-container d-flex justify-content-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Sign in to your account", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "line" }),
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, "OR")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Create a new account", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex w-50-p aside justify-content-center align-items-center\" style=\"background-color:#3e1f92;\" data-v-5c9da094><div class=\"d-flex flex-column justify-content-center align-items-center pt-10\" data-v-5c9da094><img src=\"" + _imports_2 + "\" alt=\"\" class=\"logo\" data-v-5c9da094><img src=\"" + _imports_3 + "\" alt=\"\" class=\"login-image\" data-v-5c9da094><p class=\"login-heading-text text-center\" data-v-5c9da094> Looking for the perfect tenant? Reach for the stars! </p></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_Alert, {
            color: "primary",
            title: "Information",
            text: "Please sign-in or sign-up to submit a tenant report."
          }),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signIn && _ctx.signIn(...args))),
              class: "item-option d-flex flex-column align-items-center justify-content-center"
            }, _hoisted_9),
            _hoisted_10,
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.signUp && _ctx.signUp(...args))),
              class: "item-option d-flex flex-column align-items-center justify-content-center"
            }, _hoisted_13)
          ])
        ])
      ])
    ]),
    _hoisted_14
  ]))
}